import { CALL_API } from '../middleware/api';
import * as qs from 'qs';

import serialize from 'object-to-formdata';

export const GET_SETTINGS = "GET_SETTINGS";
export const SUCCESS_GET_SETTINGS = "SUCCESS_GET_SETTINGS";
export const FAILURE_GET_SETTINGS = "FAILURE_GET_SETTINGS";

export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const SUCCESS_UPDATE_SETTINGS = "SUCCESS_UPDATE_SETTINGS";
export const FAILURE_UPDATE_SETTINGS = "FAILURE_UPDATE_SETTINGS";
export const CLEAR_UPDATE_SETTINGS = "CLEAR_UPDATE_SETTINGS";

export const DELETE_SETTINGS = "DELETE_SETTINGS";
export const SUCCESS_DELETE_SETTINGS = "SUCCESS_DELETE_SETTINGS";
export const FAILURE_DELETE_SETTINGS = "FAILURE_DELETE_SETTINGS";
export const CLEAR_DELETE_SETTINGS = "CLEAR_DELETE_SETTINGS";

export const UPDATE_BANNER = "UPDATE_BANNER";
export const SUCCESS_UPDATE_BANNER = "SUCCESS_UPDATE_BANNER";
export const FAILURE_UPDATE_BANNER = "FAILURE_UPDATE_BANNER";
export const FETCH_PROMO_SETTINGS = 'FETCH_PROMO_SETTINGS';

export const UPDATE_DROP = "UPDATE_DROP";

export function getSettings(type, key, queryParams) {
    const query = queryParams ? `?${qs.stringify(queryParams)}` : '';
    return {
        type: GET_SETTINGS,
        [CALL_API]: {
            endpoint: key ? `/api/settings/${type}/${key}${query}` : `/api/settings/${type}${query}`,
            method: 'get',
            types: [SUCCESS_GET_SETTINGS, FAILURE_GET_SETTINGS]
        },
        settingsType: type
    }
}

export function getPromoImageSettings(type) {
    return { type: FETCH_PROMO_SETTINGS, settingsType: type }
}

export function updateSettings(type, data, key, queryParams, isMultiple ) {
    const query = queryParams ? `?${qs.stringify(queryParams)}` : '';
    const dataParams = isMultiple ? serialize(data) : data
    return {
        type: UPDATE_SETTINGS,
        [CALL_API]: {
            endpoint: key ? `/api/settings/${type}/${key}${query}` : `/api/settings/${type}${query}`,
            method: 'post',
            types: [SUCCESS_UPDATE_SETTINGS, FAILURE_UPDATE_SETTINGS],
            data: dataParams,
            isFormData:  isMultiple? true : null
        },
        settingsType: type
    }
}

export function updateBanner(type, data) {
    return {
        type: UPDATE_BANNER,
        [CALL_API]: {
            endpoint: `/api/settings/${type}`,
            method: 'post',
            types: [SUCCESS_UPDATE_BANNER, FAILURE_UPDATE_BANNER],
            data: serialize(data),
            isFormData: true
        },
        settingsType: type
    }
}

export function deleteSettings(type, data) {
    return {
        type: DELETE_SETTINGS,
        [CALL_API]: {
            endpoint: `/api/settings/${type}`,
            method: 'delete',
            types: [SUCCESS_DELETE_SETTINGS, FAILURE_DELETE_SETTINGS],
            data
        },
        settingsType: type
    }
}

export function clearUpdateSettings(type) {
    return { type: CLEAR_UPDATE_SETTINGS, settingsType: type }
}

export function clearDeleteSettings(type) {
    return { type: CLEAR_DELETE_SETTINGS, settingsType: type }
}

export function updateSettingsDrop(type, data, key) {
    return {
    type: UPDATE_DROP,
    [CALL_API]: {
        endpoint: `/api/settings/${type}/${key}` ,
        method: 'post',
        types: [SUCCESS_UPDATE_SETTINGS, FAILURE_UPDATE_SETTINGS],
        data: data
    },
    settingsType: type
    }
}


// WEBPACK FOOTER //
// ./src/actions/settings.js